module.exports = __webpack_public_path__ + "img/round-send-24px.ad2a3cb2.svg";